export default __webpack_public_path__ + "static/media/a017-2.c13245c9.svg";